import axios from 'axios';
import Config from "../Config/config";
import {toast} from "react-toastify";
import { LOGOUT_URL, isNewLeadX } from '../../utils/redirection';

let isRefreshing = false;
let failedQueue = [];

const SESSION_EXPIRED = 'Session expired!';

// Helper function to process the failed requests queue
const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};

axios.interceptors.request.use(
    async (evt) => {
        if (checkTokenNeed(evt.url)) {
            // const token = await getSession();
            const token = localStorage.getItem('token');
            if(token && !evt.url.includes('recon-stg.parkplus')){
                evt.headers.Authorization = `${token}`;
                // evt.headers.source = `leadx`;
                // evt.headers['Content-Security-Policy'] = `"default-src 'self' data: blob:; connect-src 'self' ${process.env.REACT_APP_API_URL};"`;
                return evt;
            }
            if (evt.url.includes('recon-stg.parkplus')) {
                evt.headers[`client-secret`] = `${process.env.REACT_APP_CLIENT_SECRET}`;
                evt.headers[`client-id`] = `${process.env.REACT_APP_CLIENT_ID}`;
            }
            else {
                // throw new Error('session Expire');
            }
        }
        return evt;
    },
    (err) => Promise.reject(err)
);


axios.interceptors.response.use(
    async response => {
        const {data} = response;
        const originalRequest = response.config;
        if(response?.data?.status_code == 401 && !originalRequest._retry) {

            // if token refreshing mechanism is finished then reset all queued api's
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then((token) => {
                        originalRequest.headers['Authorization'] = ` ${window.localStorage.token}`;
                        return axios(originalRequest);
                    })
                    .catch((err) => Promise.reject(err));
            }

            originalRequest._retry = true;
            isRefreshing = true;

            const refreshToken = localStorage.getItem('refresh_token');
            if(!refreshToken){
                toast.warning(SESSION_EXPIRED);
                logout();
                // window.location.reload();
                return;
            }

            return new Promise((resolve, reject) => {
                    const leadxToken = localStorage.getItem('token');
                    axios.post(`${process.env.REACT_APP_API_URL}/api/v1/retry-login`, {
                        refresh_token: refreshToken,
                        user_id: localStorage.getItem('user_id'),
                        source: 'leadx'
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `${leadxToken}`
                        }
                    })
                    .then( async ({data}) => {
                        if(!data?.response?.data || !data?.response?.data?.token){
                            toast.warning(SESSION_EXPIRED);
                            logout();
                            // window.location.reload();
                            return;
                        }

                        let user_id = localStorage.getItem('user_id');
                        axios.defaults.headers.common['Authorization'] = `${data?.response?.data?.token}`;
                        originalRequest.headers['Authorization'] = `${data?.response?.data?.token}`;
                        // if(parseInt(user_id) === 397){
                            updateRefreshTokenInNative(data?.response?.data?.token);
                        // }
                        localStorage.setItem('token', data?.response?.data?.token);
                        localStorage.setItem("name",  localStorage.getItem('name'));
                        localStorage.setItem("user_id", localStorage.getItem('user_id'));
                        localStorage.setItem("active_page", localStorage.getItem('active_page'));
                        localStorage.setItem("role_id", localStorage.getItem('role_id'));
                        localStorage.setItem("refresh_token",  localStorage.getItem('refresh_token'));
                        localStorage.setItem("login_preference", localStorage.getItem('login_preference'));
                        processQueue(null, data?.response?.data?.token);

                        resolve(axios(originalRequest));
                    })
                    .catch((err) => {
                        processQueue(err, null);
                        reject(err);
                    })
                    .finally(() => {
                        isRefreshing = false;
                    });
            });
        }
        return response;
    }, // Directly return successful responses.
    async error => {
        return Promise.reject(error); // For all other errors, return the error as is.
    }
);

const logout = () => {
    let webView = window.localStorage.webview
    delete window.localStorage.clear()
    if(isNewLeadX()){
        window.location.href=LOGOUT_URL
    } else window.location.href="/"

    if(webView !== undefined && webView == 'true'){
        const message = {
            event_name: 'logout_user',
            page:"header.js profile"
        }
        const nativeObject = window.ReactNativeWebView;
        if (nativeObject !== undefined) {
            nativeObject.postMessage(JSON.stringify(message));
            window.addEventListener('message', () => {})
        }
    }
}

const updateRefreshTokenInNative = (token) => {
    let webView = window.localStorage.webview
    // delete window.localStorage.clear()
    // window.location.href="/"
    if(webView !== undefined && webView == 'true'){
        console.log("update token event fired", token)
        const message = {
            event_name: 'update_token',
            page:"interceptor.js",
            accessToken: token,
            roleId: localStorage.getItem('role_id'),
            userId: localStorage.getItem('user_id'),
            email: localStorage.getItem('userId'),
            refreshToken: localStorage.getItem('refresh_token'),
        }
        const nativeObject = window.ReactNativeWebView;
        if (nativeObject !== undefined) {
            nativeObject.postMessage(JSON.stringify(message));
            window.addEventListener('message', () => {})
        }
    }
}


const checkTokenNeed = (url) =>
    url.includes(Config.getJourneyTravelled) ||
    url.includes(Config.getJourneyTravelledByFilter) ||
    url.includes(Config.dropdown) ||
    url.includes(Config.saveAccount) ||
    url.includes(Config.updateAccount) ||
    url.includes(Config.accountDetails) ||
    url.includes(Config.getInspectionList) ||
    url.includes(Config.saveOpportunity) ||
    url.includes(Config.opportunityList) ||
    url.includes(Config.activityList) ||
    url.includes(Config.activityProposal) ||
    url.includes(Config.nextActivity) ||
    url.includes(Config.opportunityQuestion) ||
    url.includes(Config.getOpportunity) ||
    url.includes(Config.updateOpportunity) ||
    url.includes(Config.accountById) ||
    url.includes(Config.checkCloseOrDropped) ||
    url.includes(Config.fileUpload.imageUpload) ||
    url.includes(Config.fileUpload.imageUploadPublic) ||
    url.includes(Config.fileUpload.mediaUpload) ||
    url.includes(Config.fileUpload.docUpload) ||
    url.includes(Config.fileUpload.carnivalDocumentPublic) ||
    url.includes(Config.fileUpload.docUploadPublic) ||
    url.includes(Config.fileUpload.excelUpload) ||
    url.includes(Config.locations.city) ||
    url.includes(Config.locations.zone) ||
    url.includes(Config.locations.state) ||
    url.includes(Config.locations.area) ||
    url.includes(Config.locations.pinCode) ||
    url.includes(Config.googleAPI.placeSearch) ||
    url.includes(Config.fetchReportee) ||
    url.includes(Config.saveLead) ||
    url.includes(Config.getLeadById) ||
    url.includes(Config.getLead) ||
    url.includes(Config.accountFilter) ||
    url.includes(Config.leadFilter) ||
    url.includes(Config.fetchCityByStateId) ||
    url.includes(Config.leadActivities) ||
    url.includes(Config.leadActivitiesById) ||
    url.includes(Config.accountActivitiesById) ||
    url.includes(Config.opportunityFilterContent) ||
    url.includes(Config.saveLeadOrAccountActivitiesById) ||
    url.includes(Config.createSiteInspectionForm) ||
    url.includes(Config.getInspectionForm) ||
    url.includes(Config.getAllCity) ||
    url.includes(Config.inspectionCreated) ||
    url.includes(Config.activityById) ||
    url.includes(Config.HomePageContent) ||
    url.includes(Config.lastTenDaysInactiveAccount) ||
    url.includes(Config.saveNewActivity) ||
    url.includes(Config.cancelActivity) ||
    url.includes(Config.accountDetailsForTask) ||
    url.includes(Config.saveTask) ||
    url.includes(Config.updateTask) ||
    url.includes(Config.removeTask) ||
    url.includes(Config.taskTypes) ||
    url.includes(Config.taskById) ||
    url.includes(Config.taskListing) ||
    url.includes(Config.taskFilter) ||
    url.includes(Config.notification) ||
    url.includes(Config.readNotification) ||
    url.includes(Config.getProfile) ||
    url.includes(Config.changeAssignee) ||
    url.includes(Config.dealerListingForAssignee) ||
    url.includes(Config.reassignDealerManager) ||
    url.includes(Config.getDealerApprovedListing) ||
    url.includes(Config.assigneeAccount) ||
    url.includes(Config.rejectActivity) ||
    url.includes(Config.stateAndRegion) ||
    url.includes(Config.locations.saveLocation) ||
    url.includes(Config.internalGeocode) ||
    url.includes(Config.locations.getAllCity) ||
    url.includes(Config.locations.geoCity) ||
    url.includes(Config.distanceFromSite) ||
    url.includes(Config.ProposalCommercialClosure) ||
    url.includes(Config.maintenanceCost) ||
    url.includes(Config.getDetails) ||
    url.includes(Config.dealerProfileData) ||
    url.includes(Config.attendance) ||
    url.includes(Config.moduleActivity) ||
    url.includes(Config.isUserCheckout) ||
    url.includes(Config.dealerActivityTypes) ||
    url.includes(Config.saveActivityOnModules) ||
    url.includes(Config.dearlerById) ||
    url.includes(Config.attendanceDealerLead) ||
    url.includes(Config.moduleDealerLeadActivity) ||
    url.includes(Config.isUserDealerLeadCheckout) ||
    url.includes(Config.saveActivityOnDealerLead) ||
    url.includes(Config.rescheduleActivity) ||
    url.includes(Config.getSenior) ||
    url.includes(Config.UpdateTaggedAlong) ||
    url.includes(Config.taggedAlongList) ||
    url.includes(Config.taggedAlongById) ||
    url.includes(Config.addTaggedAlong) ||
    url.includes(Config.leadGateTypes) ||
    url.includes(Config.activityFilter) ||
    url.includes(Config.homeFilter) ||
    url.includes(Config.lastCheckIn) ||
    url.includes(Config.FasttagTollActivityType) ||
    url.includes(Config.FasttagTollActivitySave) ||
    url.includes(Config.FasttagTollPendingActivity) ||
    url.includes(Config.FasttagTollAttendance) ||
    url.includes(Config.FasttagTollIsCheckout) ||
    url.includes(Config.FasttagTollSave) ||
    url.includes(Config.FasttagTollAccountList) ||
    url.includes(Config.tollById) ||
    url.includes(Config.tollFilter) ||
    url.includes(Config.tollApprovePending) ||
    url.includes(Config.tollActivityApprove) ||
    url.includes(Config.FSEDetails) ||
    url.includes(Config.AMByAsm) ||
    url.includes(Config.AmToll) ||
    url.includes(Config.AmTollMonthlyPlan) ||
    url.includes(Config.PJPReview) ||
    url.includes(Config.PJPPendingList) ||
    url.includes(Config.PJPPendingApprove) ||
    url.includes(Config.fseOTPGeneration) ||
    url.includes(Config.saveFSEs) ||
    url.includes(Config.FSEsDetailsByPJPId) ||
    url.includes(Config.pjpDetailsById) ||
    url.includes(Config.inactiveFseDetails) ||
    url.includes(Config.fseActivationCheck) ||
    url.includes(Config.valetAccountSave) ||
    url.includes(Config.valetAccountList) ||
    url.includes(Config.valetAccountById) ||
    url.includes(Config.valetActivitySave) ||
    url.includes(Config.valetAccountFilter) ||
    url.includes(Config.fseInventory) ||
    url.includes(Config.fseTagTransfer) ||
    url.includes(Config.callLogs) ||
    url.includes(Config.getAllDays) ||
    url.includes(Config.saveAttendanceRegularization) ||
    url.includes(Config.getRegularizationDetails) ||
    url.includes(Config.markNonSiteCheckIn) ||
    url.includes(Config.updateRegularizationDetails) ||
    url.includes(Config.getMonthsFilter) ||
    url.includes(Config.getRegularizationFilter) ||
    url.includes(Config.meetingDataForParticularDate) ||
    url.includes(Config.getAttendanceDetails) ||
    url.includes(Config.markNonSiteCheckOut) ||
    url.includes(Config.tollPendingMeeting) ||
    url.includes(Config.errorLogs) ||
    url.includes(Config.nearestPlazaFromOperatorLocation) ||
    url.includes(Config.checkSBIIssuance) ||
    url.includes(Config.CarServiceActivityType) ||
    url.includes(Config.carServiceActivitySave) ||
    url.includes(Config.carServiceAttendance) ||
    url.includes(Config.carServiceIsCheckout) ||
    url.includes(Config.carServicePendingActivity) ||
    url.includes(Config.carServiceOpportunity) ||
    url.includes(Config.carServiceAccount) ||
    url.includes(Config.sitePocType) ||
    url.includes(Config.oemManufactureName) ||
    url.includes(Config.carServiceAccountFilter) ||
    url.includes(Config.valetPendingActivity) ||
    url.includes(Config.parkingSaveActivity) ||
    url.includes(Config.parkingPendingActivity) ||
    url.includes(Config.parkingAttendance) ||
    url.includes(Config.parkingAccountList) ||
    url.includes(Config.parkingAccountSave) ||
    url.includes(Config.baSaveActivity) ||
    url.includes(Config.baPendingActivity) ||
    url.includes(Config.baAttendance) ||
    url.includes(Config.baAccountList) ||
    url.includes(Config.accountByLeadId) ||
    url.includes(Config.SaveActivityByModule) ||
    url.includes(Config.pendingActivityByModule) ||
    url.includes(Config.attendanceByModule) ||
    url.includes(Config.attendanceRequest) ||
    url.includes(Config.attendanceRequestList) ||
    url.includes(Config.journeySave) ||
    url.includes(Config.getJourney) ||
    url.includes(Config.baOpportunity) ||
    url.includes(Config.postClosure) ||
    url.includes(Config.existingSite) ||
    url.includes(Config.siteVisitValet) ||
    url.includes(Config.siteVisitValetList) ||
    url.includes(Config.valetOperationProjectById) ||
    url.includes(Config.v2OpportunityActivity) ||
    url.includes(Config.lastLeadOpportunityActivity) ||
    url.includes(Config.userCheckInForModule) ||
    url.includes(Config.meetingRating) ||
    url.includes(Config.juniorListingForHod) ||
    url.includes(Config.starCheck) ||
    url.includes(Config.emailDropdown) ||
    url.includes(Config.smByUserId) ||
    url.includes(Config.rmViewDetails) ||
    url.includes(Config.selfRatingDetails) ||
    url.includes(Config.userRating) ||
    url.includes(Config.selectedTaggedAlong) ||
    url.includes(Config.businessProject) ||
    url.includes(Config.businessSaveProject) ||
    url.includes(Config.searchDealerMaster) ||
    url.includes(Config.dealerHeathCard) ||
    url.includes(Config.UCDVerify) ||
    url.includes(Config.UCDDealerById) ||
    url.includes(Config.ucdSave) ||
    url.includes(Config.otpGenerate) ||
    url.includes(Config.ucdList) ||
    url.includes(Config.firmTypes) ||
    url.includes(Config.ucdUpdate) ||
    url.includes(Config.locations.locationType)||
    url.includes(Config.getDealerPoc)||
    url.includes(Config.pendingLeads)||
    url.includes(Config.leadApproval)||
    url.includes(Config.carBrand)||
    url.includes(Config.carModel)||
    url.includes(Config.carVariant)||
    url.includes(Config.bankList)||
    url.includes(Config.newCase)||
    url.includes(Config.caseByLsqDealerId)||
    url.includes(Config.updateCaseStatus)||
    url.includes(Config.caseListing)||
    url.includes(Config.caseById)||
    url.includes(Config.loanApplicationById)||
    url.includes(Config.loanApplicationUpdate)||
    url.includes(Config.leadAddressApprovalList)||
    url.includes(Config.leadAddressPendingById)||
    url.includes(Config.leadAddressApprovalAction)||
    url.includes(Config.addressUpdateLogs)||
    url.includes(Config.raisePayment)||
    url.includes(Config.loanAccount)||
    url.includes(Config.loanUndertaking)||
    url.includes(Config.approvalRequest)||
    url.includes(Config.loanTranches)||
    url.includes(Config.raisePaymentUpdate)||
    url.includes(Config.payoutDetailsUpdate)||
    url.includes(Config.getPayoutDetails)||
    url.includes(Config.newBankDetails)||
    url.includes(Config.updateTrancheStatus)||
    url.includes(Config.foreClosureAccountDetails)||
    url.includes(Config.vehicleDetails)||
    url.includes(Config.agreementNotification)||
    url.includes(Config.checkAgreementVerified)||
    url.includes(Config.rcCaseById)||
    url.includes(Config.updateDealerPoc)||
    url.includes(Config.createReferral)||
    url.includes(Config.getDropdownProjectTypes)||   
    url.includes(Config.approveReferral)||
    url.includes(Config.getReferralDetails)||
    url.includes(Config.getReferralList)||
    url.includes(Config.fileComplain.createFdTickets)||
    url.includes(Config.meetingMomSend)||
    url.includes(Config.momList)||
    url.includes(Config.momById)||
    url.includes(Config.externalMomList)||
    url.includes(Config.fileComplain.fetchAllIssue)||
    url.includes(Config.getAccountsForCalling)||
    url.includes(Config.saveReferralCallForm)||
    url.includes(Config.getReferralCallLogs)||
    url.includes(Config.getReferralCallFilters)||
    url.includes(Config.checkDeviceId)||
    url.includes(Config.dashboardContent)||
    url.includes(Config.heatMap)||
    url.includes(Config.meetingBtId)||
    url.includes(Config.getPreviousActivities)||
    url.includes(Config.getAllLeads)||
    url.includes(Config.getLeadDetails)||
    url.includes(Config.getLeadFilters)||
    url.includes(Config.updateLeadStatus)||
    url.includes(Config.updateLeadAccount)||
    url.includes(Config.createNewLead)||
    url.includes(Config.fetchPanDetails);

export default axios;